/**
 * Message match cuando Shopify sirve HTML cacheada de ?view=ads sin el query angle=.
 * Liquid ideal: ?view=ads-educacion. Este script corrige H1/subtitle/bullets si la URL
 * pide educacion pero data-ads-angle="default".
 */
(function () {
  if (window.__menvoraAdsAngleSync) return;
  window.__menvoraAdsAngleSync = true;

  var EDU_ALIASES = ['educacion', 'ritual', 'educacion-ritual', 'como-tomar'];

  function angleFromUrl() {
    try {
      var p = new URLSearchParams(window.location.search);
      var view = (p.get('view') || '').toLowerCase();
      if (view.indexOf('ads-educacion') >= 0) return 'educacion';
      if (view.indexOf('ads-comparativo') >= 0) return 'comparativo';
      var raw = (
        p.get('angle') ||
        p.get('angulo') ||
        p.get('ángulo') ||
        p.get('lp') ||
        ''
      )
        .trim()
        .toLowerCase();
      if (EDU_ALIASES.indexOf(raw) >= 0) return 'educacion';
      if (raw === 'comparativo') return 'comparativo';
    } catch (e) {
      /* ignore */
    }
    return 'default';
  }

  function readPack() {
    var el = document.getElementById('menvora-ads-angle-pack');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return null;
    }
  }

  function cortisolFallback(angle) {
    if (window.location.pathname.indexOf('suplemento-cortisol-calm-megneta-60cp') < 0) {
      return null;
    }
    if (angle === 'educacion') {
      return {
        h1: 'Ritual nocturno — no es un somnífero',
        subtitle: '1–2 cápsulas · ~1 hora antes de dormir · Megneta',
        bullets: '~1 hora antes\nCelular fuera\nRelaja la mente',
      };
    }
    return null;
  }

  function resolveCopy(angle, pack) {
    var copy = pack && pack[angle] ? Object.assign({}, pack[angle]) : null;
    if (!copy || !copy.h1) {
      var fb = cortisolFallback(angle);
      if (fb) copy = Object.assign(copy || {}, fb);
    }
    return copy;
  }

  function setText(el, text) {
    if (!el || text == null || text === '') return;
    el.textContent = text;
  }

  function renderBullets(container, bulletsRaw) {
    if (!container || !bulletsRaw) return;
    var lines = String(bulletsRaw).split(/\r?\n/);
    container.innerHTML = '';
    var shown = 0;
    lines.forEach(function (line) {
      if (shown >= 3) return;
      var clean = line.replace(/<[^>]+>/g, '').trim();
      if (!clean) return;
      var p = document.createElement('p');
      p.className = 'menvora-atf-bullets__item';
      p.setAttribute('role', 'listitem');
      p.textContent = clean;
      container.appendChild(p);
      shown += 1;
    });
  }

  function apply(angle, copy) {
    if (!copy || !copy.h1) return;

    var root = document.querySelector('.product--ads-stack[data-ads-angle]');
    if (root) root.setAttribute('data-ads-angle', angle);

    var titleWrap = document.querySelector('.product--ads-stack .product__title');
    if (titleWrap) {
      setText(titleWrap.querySelector('h1'), copy.h1);
      setText(titleWrap.querySelector('h2.h1'), copy.h1);
    }

    var subtitleEl = document.querySelector('.product--ads-stack .menvora-atf-subtitle');
    if (copy.subtitle) {
      if (subtitleEl) {
        setText(subtitleEl, copy.subtitle);
      } else if (titleWrap && titleWrap.parentNode) {
        var sub = document.createElement('p');
        sub.className = 'product__text caption-with-letter-spacing menvora-atf-subtitle';
        sub.textContent = copy.subtitle;
        titleWrap.parentNode.insertBefore(sub, titleWrap.nextSibling);
        subtitleEl = sub;
      }
    }

    if (copy.bullets) {
      var bulletsEl = document.querySelector('.product--ads-stack .menvora-atf-bullets');
      if (bulletsEl) {
        renderBullets(bulletsEl, copy.bullets);
      } else {
        var anchor = subtitleEl || titleWrap;
        if (anchor && anchor.parentNode) {
          var wrap = document.createElement('div');
          wrap.className = 'product__text menvora-atf-bullets';
          wrap.setAttribute('role', 'list');
          renderBullets(wrap, copy.bullets);
          anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
        }
      }
    }

    document.dispatchEvent(
      new CustomEvent('menvora:ads-angle-sync', { detail: { angle: angle } })
    );
  }

  function sync() {
    var urlAngle = angleFromUrl();
    if (urlAngle === 'default') return;

    var root = document.querySelector('.product--ads-stack[data-ads-angle]');
    if (!root) return;

    var domAngle = root.getAttribute('data-ads-angle') || 'default';
    if (domAngle === urlAngle) return;

    var copy = resolveCopy(urlAngle, readPack());
    if (copy && copy.h1) apply(urlAngle, copy);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync, { once: true });
  } else {
    sync();
  }
})();
